import { render } from "./FooterLogo.vue?vue&type=template&id=2b225836&scoped=true"
const script = {}

import "./FooterLogo.vue?vue&type=style&index=0&id=2b225836&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b225836"]])

export default __exports__